import { Injectable } from '@angular/core';
import { ApiService } from './api.base.service';
import { IWService } from '../iw.service';
import { ApiDocumentProcessGridModel } from '../../models/api-document-process-grid.model';
import { SignatureResponse, SignatureResponseWithoutWallet } from '../../models/signature-response';
import { GetContent, GetContentWithoutWallet } from '../../models/get-content';
import { SDKOperationRequest } from '@extrimian/identity-wallet';
import { SignContent } from '../../models/sign-content';
import { ApiDocumentProcessModel } from '../../models/api-document-process.model';
import { VerifyResponse } from '../../models/verify-response.model';
import { DocumentParams } from '../../models/api-models/document-params-model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PagedList } from '../../models/pagination';

@Injectable({ providedIn: "root" })
export class DocumentProcessService {
    baseUrl = "api/document-signature";
    documents: Document[] = []; // -jjlovaglio
    paginatedResult: PagedList<Document[]> = new PagedList<Document[]>();

    constructor(
        private apiService: ApiService,
        private iwService: IWService,
        public http: HttpClient
    ) { }

    async getDocuments(page?: number, itemsPerPage?: number): Promise<PagedList<ApiDocumentProcessModel>> {
        
        return  await this.apiService.get<PagedList<ApiDocumentProcessModel>>(`${this.baseUrl}/documents/${page}/${itemsPerPage}`);
    }

    async extrSignProcessDocument(documentId: number, language: string) {
        // verificar si quitamos el IW - es el identitiWallet
        var fromAddress: string;
        fromAddress = await (await this.iwService.getIW()).getMainAddress();
        var response: SignatureResponseWithoutWallet;

        let getContent: GetContentWithoutWallet = {
            RootObjectId: documentId,
            language: language,
            fromAddress: fromAddress,
        };

        response = await await this.apiService.post<SignatureResponseWithoutWallet>(
            `${this.baseUrl}/getdocumentcontent`,
            getContent
        );
       
        if (response != null) {
            let signContent: SignContent = {
                fromAddress: fromAddress,
                signatureId: response.signatureId,
                signature: '',
            };
            return await this.apiService.post(
                `${this.baseUrl}/documentsigncontent`,
                signContent
            );
        } else {
            return;
        }
    }
    
    //TODO: verificar si este rollBack se usa en otra instacia sino se podria quitar
    async rollBackDocumentSignContent(documentId: number) {
        return await this.apiService.post(
            `${this.baseUrl}/rollbackdocumentsigncontent/${documentId}`
        );
    }

    async verifyDocument(fileDescriptorId: string): Promise<VerifyResponse> {
        return await this.apiService.get(
            `${this.baseUrl}/verify/${fileDescriptorId}`
        );
    }

    async getDocumentProcessDetails(documentProcessId: number): Promise<ApiDocumentProcessModel> {
        return await this.apiService.get(
            `${this.baseUrl}/getdocumentprocessdetails/${documentProcessId}`
        );
    }

    async generateQRCodeFileAsync(documentProcessId: number): Promise<void> {
        let file = await this.http.get(this.baseUrl + `/generateqrcodefileasync/${documentProcessId}`, {
            responseType: 'blob'
        }).toPromise();

        let todayDate = new Date();
        let fileName = `document-${documentProcessId}-${todayDate.toISOString()}.pdf`;
        this.downloadFile(file, fileName);
    }

    downloadFile(data: Blob, fileName: string) {
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(data);
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    


}
